/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseRecharge } from '../../models/api-response-recharge';
import { Recharge } from '../../models/recharge';

export interface UpdateRecharge$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: Recharge
}

export function updateRecharge(http: HttpClient, rootUrl: string, params: UpdateRecharge$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseRecharge>> {
  const rb = new RequestBuilder(rootUrl, updateRecharge.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseRecharge>;
    })
  );
}

updateRecharge.PATH = '/v1/api/ui/meta-pricing-analytics/recharge/{ref}';
